import type {
    IResponseApi,
} from '@/modules/Core/interfaces/api/IApis'
import { BaseService } from '@/modules/Core/services/BaseService'
import type { AxiosResponse } from 'axios'
import type { IRecurso, ITiposGeneralRecurso } from '../interfaces/recurso'

export interface IRecursoFile {
    base64: string
    mimeType: string
}

export class RecursoService extends BaseService<IRecurso> {
    constructor() {
        super({
            baseUrl: 'system/resource/'
        })
    }

    async getGeneral(): Promise<AxiosResponse<IResponseApi<ITiposGeneralRecurso>>> {
        return this.http.get<IResponseApi<ITiposGeneralRecurso>>(`/general`)
    }

    async getRecursosLicencia(): Promise<AxiosResponse<IResponseApi<IRecurso[]>>> {
        return this.http.get<IResponseApi<IRecurso[]>>(`/license`)
    }

    async getRecursoFile(id: number): Promise<AxiosResponse<IResponseApi<IRecursoFile>>> {
        return this.http.get<IResponseApi<IRecursoFile>>(`/file/${id}`).catch(this.errorHandle)
    }

}
